import React from 'react'

const PILAccept = ({ color = '#0FB680', size = 17 }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 17 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      {/* Green Circle */}
      <circle cx="8.5" cy="8.5" r="7.5" fill={color} />

      {/* Tick Only */}
      <path
        d="M11 6.83333L7.66667 10.1667L6 8.5"
        stroke="white"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default PILAccept